module.exports = __webpack_public_path__ + "9bc65c43e215991881a6cfea3740e8af.svg";